export const LOAN_GEEK_URL= "/resource/auth/ps4/property/integrations/loangeek/deals"